import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CancelIcon from '@mui/icons-material/Cancel';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'; // or another appropriate package
import { faVolleyball } from '@fortawesome/free-solid-svg-icons';
import { IconButton, Tooltip, TableCell, Modal, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';

function CustomerIndex() {
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }

    // const fetchtableData = async () => {
    //   // Add your logic to fetch table data here
    //   await handleExperingWarrantyClick(companyId, userId);

    // };

    fetchtableData();
  }, [isAuthenticated, companyId, userId, token, logout]);


  useEffect(() => {
    fetchtableData();
  }, []);

  // const fetchtableData = async () => {
  //   setLoading(true);
  //   fetchData('CustomerApi', `/${companyId}`, token)
  //     .then((response) => {
  //       if (response.responseCode == '1111') {
  //         console.log(response);
  //         setData(response.response_data);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error('Error fetching Customer Details:', error);
  //     })
  //     finally {
  //       setLoading(false); // Hide loading screen
  //   }
  // };
  const fetchtableData = async () => {
    setLoading(true);
    try {
      const response = await fetchData('CustomerApi', `/${companyId}`, token);
      if (response.responseCode == '1111') {
        console.log(response);
        setData(response.response_data);
      }
    } catch (error) {
      console.error('Error fetching Customer Details:', error);
    } finally {
      setLoading(false); // Hide loading screen
    }
  };

  const handleDelete = async () => {
    deleteData('CustomerApi', `${deleteItemId}`, token)
      .then((response) => {
        fetchtableData();
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });

  };

  const handleActivate = (itemId) => {
    activateData('CustomerApi', `${itemId}`, token)
      .then((response) => {
        fetchtableData();
      })
      .catch((error) => {
      });
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };

  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchInput = () => {
    setShowSearchInput(!showSearchInput);
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function isExpired(dateString) {
    const currentDate = new Date();
    const date = new Date(dateString);
    return date < currentDate;
  }

  //Experied Customer data 
  const [warrantytData, setWarrantyData] = useState([]);
  const [isWarrantyModalOpen, setIsWarrantyModalOpen] = useState(false);
  const [expiredWarrantyCount, setExpiredWarrantyCount] = useState(0);

  const openAppointmentModal = () => setIsWarrantyModalOpen(true);
  const closeAppointmentModal = () => setIsWarrantyModalOpen(false);

  const handleWarrantyClick = async (companyId, userId) => {
    try {
      // const response = await fetchData('CustomerApi', companyId, userId,token);
      const response = await fetchData('CustomerApi', `/RequestDetails/${companyId}/${userId}`, token);
      if (response.responseCode === '1111') {
        setWarrantyData(response.response_data);
        setExpiredWarrantyCount(response.response_data.length);
        console.log(response);
        openAppointmentModal();
      }
    } catch (error) {
      console.error('Error occurred while fetching Warranty data:', error);
    }
  };

  // //Expering customer data

  const [experingwarrantytData, setExperingWarrantyData] = useState([]);
  const [isexperingWarrantyModalOpen, setIsExperingWarrantyModalOpen] = useState(false);
  const [expiringWarrantyCount, setExpiringWarrantyCount] = useState(0);


  const openexperingdataModal = () => setIsExperingWarrantyModalOpen(true);
  const closeExperingModal = () => setIsExperingWarrantyModalOpen(false);

  const handleExperingWarrantyClick = async (companyId, userId) => {
    try {
      const response = await fetchData('CustomerTypeApi', `/RequestDetails/${companyId}/${userId}`, token);
      if (response.responseCode === '1111') {
        const warrantyData = response.response_data;
        setExperingWarrantyData(warrantyData);
        const count = warrantyData.length;
        setExpiringWarrantyCount(count);

        if (count > 0) {
          console.log(response);
          openexperingdataModal();
        }
      }
    } catch (error) {
      console.error('Error occurred while fetching Warranty data:', error);
    }
  };


  useEffect(() => {
    // Inject keyframes into the document head
    const styleSheet = document.styleSheets[0];
    const keyframes =
      `@keyframes blink {
        0% { opacity: 1; }
        50% { opacity: 0; }
        100% { opacity: 1; }
      }`;
    styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
  }, []);

  const [Remark, setRemark] = useState([]);
  const [formData, setFormData] = useState({

    datas: {
      ID: '',
      CompanyID: '',
      CustomerTypeID: '',
      CustomerName: '',
      ContactNumber1: '',
      ContactNumber2: '',
      AddressLine1: '',
      AddressLine2: '',
      LandMark: '',
      Town: '',
      District: '',
      State: '',
      Country: '',
      PostalId: '',
      PinCode: '',
      GPSLocation: '',
      ContactPerson: '',
      GSTNumber: '',
      Email: '',
      CustomerRemark: Remark,

    }
  });

  const [selectedAMC, setSelectedAMC] = useState("1");

  const handleChange = event => {

    const { name, value, type, checked } = event.target;
    setSelectedAMC(event.target.value);
    setFormData(prevData => ({
      ...prevData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };


  const [open, setOpen] = useState(false);
  //const [formData, setFormData] = useState(null);
  const [customerId, setCustomerId] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleStatusClick = async (Id) => {
    handleOpen();

    try {
      const response = await fetchData('CustomerApi', `/CustomerEdit/${Id}`, token);
      if (response.responseCode === '1111') {
        setFormData(response.response_data);
        setCustomerId(response.response_data.id);
        console.log(response);
        handleOpen();
      }
    } catch (error) {
      console.error('Error occurred while fetching Warranty data:', error);
    }
  };


  const handleSubmit = (event) => {
    event.preventDefault();
    setIsLoading(true);

    const updatedFormData = {
      ...formData,
      UpdatedBy: userId,
      CustomerRemark: Remark,
    };


    updateData('AMCApi', `${customerId}`, updatedFormData, token)
      .then((response) => {
        console.log('Record updated successfully:', response.data);
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error updating record:', error);
        setIsLoading(false);
      });
  };


  return (
    <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '99%' }}>
      <div className='w-full mb-2 flex'>
        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>CUSTOMER</h6>
        {loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div>
              <CircularProgress style={{ color: 'white' }} />
              <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
            </div>
          </div>
        )}
        <Tooltip title="Engineer's Appointment summary">
          <Button
            onClick={() => handleExperingWarrantyClick(companyId, userId)}
            style={{ marginLeft: '10px', color: 'white', fontWeight: 'bolder', backgroundColor: 'darkblue' }}
          >
            Warranty Expiring ({expiringWarrantyCount})  <FontAwesomeIcon
              icon={faTriangleExclamation}
              style={{
                marginLeft: '5px',
                color: 'yellow',
                height: '20px',
                animation: 'blink 1s infinite'
              }}
            />
          </Button>
        </Tooltip>

        <Tooltip title="Engineer's Appointment summary">
          <Button onClick={() => handleWarrantyClick(companyId, userId)} style={{ marginLeft: '10px', color: 'white', fontWeight: 'bolder', backgroundColor: 'darkred' }}>
            Warranty Expired ({expiredWarrantyCount})  <WorkspacesIcon
              style={{
                marginLeft: '5px',
                color: 'white',
                animation: 'circular 2s infinite linear'
              }}
            />
          </Button>
        </Tooltip>

        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
          <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
          {showSearchInput && (
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ marginLeft: '10px', width: '200px' }}
            />
          )}
        </div>
        <Tooltip title="Create New Customer">
          <Link to="/CustomerCreate" className="inline-block">
            <Button style={{ fontWeight: 'bolder' }}>
              <AddIcon style={{ fontWeight: 'bolder' }} /> Create
            </Button>
          </Link>
        </Tooltip>
      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead sx={{ backgroundColor: '#090040' }}>
              <TableRow>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', width: '10px' }}>Sl.No</TableCell>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', width: '150px' }}>Name</TableCell>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', width: '100px' }}>Contact No</TableCell>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', width: '250px' }}>Address</TableCell>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', width: '90px' }}>LandMark</TableCell>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', width: '100px' }}>District</TableCell>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', width: '100px' }}>AMC</TableCell>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', width: '100px' }}>Expired on</TableCell>
                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase', textAlign: 'right', width: '100px' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((item, index) => (
                <TableRow key={item.Id}>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', width: '10px' }}>{index + 1}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', width: '150px' }}>{item.customerName}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', width: '100px' }}>{item.contactNumber1} , {item.contactNumber2} </TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', width: '250px' }}>{item.addressLine1}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', width: '90px' }}>{item.landMark}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', width: '100px' }}>{item.district}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', width: '100px' }}>
                    {item.amCwarranty}
                  </TableCell>

                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px', width: '100px' }}>
                    <span style={{ color: 'blue' }}>
                      {item.warrentyExpireDate ? (
                        isExpired(item.warrentyExpireDate) ? (
                          <span style={{ color: 'red' }}>{`Expired (${formatDate(item.warrentyExpireDate)})`}</span>
                        ) : (
                          formatDate(item.warrentyExpireDate)
                        )
                      ) : (
                        <span style={{ color: 'red' }}>Not Updated</span>
                      )}
                    </span>

                  </TableCell>

                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'right', fontSize: '12px', width: '100px' }}>
                    <Link to={`/CustomerEdit/${item.id}`}>
                      <Tooltip title="Edit Customer">
                        <IconButton>
                          <EditIcon style={{ color: '#4682B4', fontSize: '19px' }} />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Tooltip title="Delete Customer">
                      <IconButton onClick={() => openConfirmDialog(item.id)}>
                        <DeleteIcon style={{ color: 'red', fontSize: '19px' }} />
                      </IconButton>
                    </Tooltip>

                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <button
                  onClick={closeConfirmDialog}
                  style={{
                    backgroundColor: '#dc3545',
                    color: '#ffffff',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    marginRight: '8px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    border: '1px solid #28a745',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                  }}
                >
                  Confirm
                </button>
              </DialogActions>

            </Dialog>
          </Table>
        </TableContainer>

        {/* Expired Customer Details  */}

        <Modal open={isWarrantyModalOpen} onClose={closeAppointmentModal} className={isWarrantyModalOpen ? 'notification-modal' : ''}>
          <div className="fixed inset-0 flex items-center justify-center z-10">
            <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '900px', overflowY: 'auto' }}>
              <div className='w-full mb-2 flex justify-end'>
                <Tooltip title="Close">
                  <button className="close-button" onClick={closeAppointmentModal} style={{ marginLeft: '8px' }}><CancelIcon /></button>
                </Tooltip>
              </div>
              <h6 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'brown', marginTop: '-40px', fontWeight: 'bolder' }}>WARRANTY EXPIRED DETAILS</h6>
              <br></br>

              <TableContainer component={Paper} style={{ overflowY: 'auto' }}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                    <TableRow>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textTransform: 'uppercase' }}>Customer</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textTransform: 'uppercase' }}>Contact No</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textTransform: 'uppercase' }}>Warranty Expired</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textAlign: 'right', textTransform: 'uppercase' }}>Update Status</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {warrantytData.map((item, index) => (
                      <TableRow key={item.Id}>
                        <TableCell sx={{ fontSize: '13px', padding: '2px' }}>{index + 1}</TableCell>
                        <TableCell sx={{ fontSize: '13px', padding: '2px', color: 'darkmagenta', fontWeight: 'bolder' }}>{item.customerName}</TableCell>
                        <TableCell sx={{ fontSize: '13px', padding: '2px' }}>{item.contactNumber1}</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '13px', padding: '2px', color: 'red' }}>
                          {isExpired(item.warrentyExpireDate) ? `Expired on ${formatDate(item.warrentyExpireDate)}` : formatDate(item.warrentyExpireDate)}
                        </TableCell>
                        <TableCell sx={{ color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'right', fontSize: '13px' }}>

                          <Tooltip title="Update the Warranty Status">
                            <IconButton>
                              <FontAwesomeIcon icon={faVolleyball} style={{ color: 'darkred', fontSize: '19px' }} onClick={() => handleStatusClick(item.id)} />
                            </IconButton>
                          </Tooltip>

                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </Modal>

        {/* Expering Customer Details  (One Week) - like alert  */}

        <Modal open={isexperingWarrantyModalOpen} onClose={closeExperingModal} className={isexperingWarrantyModalOpen ? 'notification-modal' : ''}>
          <div className="fixed inset-0 flex items-center justify-center z-10">
            <div className="p-6 rounded-lg shadow-lg" style={{ width: '900px', overflowY: 'auto', backgroundColor: '#FFD801' }}>
              <div className='w-full mb-2 flex justify-end'>
                <Tooltip title="Close">
                  <button className="close-button" onClick={closeExperingModal} style={{ marginLeft: '8px' }}><CancelIcon /></button>
                </Tooltip>
              </div>
              <h6 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'black', marginTop: '-40px', fontWeight: 'bolder' }}>WARRANTY EXPIRING DETAILS</h6>
              <br></br>

              <TableContainer component={Paper} style={{ overflowY: 'auto', marginTop: '-20px' }}>
                <Table>
                  <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                    <TableRow>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textTransform: 'uppercase' }}>Sl.No</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textTransform: 'uppercase' }}>Customer</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textTransform: 'uppercase' }}>Contact No</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textTransform: 'uppercase' }}>Expired Date</TableCell>
                      <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '5px', textAlign: 'right', textTransform: 'uppercase' }}>Status Update</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {experingwarrantytData.map((item, index) => (
                      <TableRow key={item.Id}>
                        <TableCell sx={{ fontSize: '13px', padding: '2px' }}>{index + 1}</TableCell>
                        <TableCell sx={{ fontSize: '13px', padding: '2px', color: 'darkmagenta', fontWeight: 'bolder' }}>{item.customerName}</TableCell>
                        <TableCell sx={{ fontSize: '13px', padding: '2px' }}>{item.contactNumber1}</TableCell>
                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '13px', padding: '2px', color: 'red' }}>
                          {isExpired(item.warrentyExpireDate) ? `Expired on ${formatDate(item.warrentyExpireDate)}` : formatDate(item.warrentyExpireDate)}
                        </TableCell>
                        <TableCell sx={{ color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'right', fontSize: '13px' }}>

                          <Tooltip title="Update the Warranty Status">
                            <IconButton>
                              <FontAwesomeIcon icon={faVolleyball} style={{ color: 'darkmagenta', fontSize: '19px' }} onClick={() => handleStatusClick(item.id)} />
                            </IconButton>
                          </Tooltip>

                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </Modal>

        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              border: '2px solid #000',
              boxShadow: 24,
              p: 4,
              width: '700px'
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Tooltip title="Update">
                <Button
                  onClick={handleSubmit}
                  style={{ color: 'green', fontWeight: 'bolder' }}
                  disabled={isLoading}
                >
                  {isLoading ? <CircularProgress size={24} color="inherit" /> : "Update"} <CheckCircleIcon />
                </Button>
              </Tooltip>
            </div>
            <h6 style={{ textAlign: 'center', color: 'darkblue' }}>WARRANTY STATUS UPDATION</h6>
            <br></br>
            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label className="block tracking-wide text-black text-xs  mb-2" htmlFor="code" style={{ fontSize: '14px' }}>
                  Name
                </label>

                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="customerName"
                  value={formData.customerName}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Name"
                />
              </div>
              <div className="w-1/4 mr-2">
                <label className="block tracking-wide text-black text-base  mb-2" htmlFor="contactNumber1">
                  Contact Number
                </label>
                <input
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  name="contactNumber1"
                  value={formData.contactNumber1}
                  onChange={handleChange}
                  type="text"
                  placeholder="Enter Contact Number 1"
                />
              </div>
              <div className="w-1/7 radio-group" style={{ marginLeft: '10px' }}>
                <div className="flex items-center">
                  <label className="block uppercase tracking-wide  mr-2" style={{ color: 'orangered' }}>
                    <input type="radio"
                      name="amc"
                      value="1"
                      checked={formData.amc?.toString() === '1'}
                      onChange={handleChange} />
                    non-AMC
                  </label>

                  <label className="block uppercase tracking-wide  mr-2" style={{ color: 'darkgreen' }}>
                    <input type="radio"
                      name="amc"
                      value="2"
                      checked={formData.amc?.toString() === '2'}
                      onChange={handleChange} />
                    AMC
                  </label>
                </div>
              </div>
            </div>

            <div className="w-full mb-4 flex">
              <div className="w-1/2 mr-2">
                <label
                  className="block tracking-wide text-black text-xs mb-2 mr-4"
                  htmlFor="warrentyExpireDate"
                  style={{ fontSize: '15px', fontWeight: 'bolder' }}
                >
                  Warranty Expired Date
                </label>
                <input
                  type="date"
                  name="warrentyExpireDate"
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  value={formData.warrentyExpireDate ? formData.warrentyExpireDate.split('T')[0] : ''}
                  onChange={handleChange}
                  disabled
                />
              </div>

              <div className="w-1/2 mr-2">
                <label
                  className="block tracking-wide text-black text-xs mb-2 mr-4"
                  htmlFor="renewalExpireDate"
                  style={{ fontSize: '15px', fontWeight: 'bolder' }}
                >
                  Renewal Date
                </label>
                <input
                  type="date"
                  name="renewalExpireDate"
                  className="mt-1 block w-full border-gray-300 rounded-md shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                  value={formData.renewalExpireDate || ''}
                  onChange={handleChange}
                />
              </div>
            </div>
            {/* <div className="w-full mb-4 flex">
              <div className="w-full mr-1 ">
                <label className="block tracking-wide text-black text-xs mb-2" htmlFor="packingDate" style={{ fontSize: '16px' }}>
                  Remark
                </label>
                <textarea
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  value={Remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Enter Remarks"
                  rows={3}
                  maxLength={250}
                />
              </div>
            </div> */}
            <div className="w-full mb-4 flex">
              <div className="w-full mr-1">
                <label className="block tracking-wide text-black text-xs mb-2" htmlFor="remark" style={{ fontSize: '16px' }}>
                  Remark
                </label>
                <textarea
                  id="remark"
                  className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                  value={Remark}
                  onChange={(e) => setRemark(e.target.value)}
                  placeholder="Enter Remarks"
                  rows={3}
                  maxLength={250}
                />
              </div>
            </div>
          </Box>
        </Modal>
      </div >
    </div >
  );
}

export default CustomerIndex;

